<div *ngIf="(isLoggedIn$ | async) && (banner$ | async) as banner">
  <div
    *ngIf="banner.isActive && banner.message?.trim()"
    class="custom-banner"
    role="status"
    aria-live="polite"
    aria-atomic="true"
    #bannerContainer
    id="site-banner"
    tabindex="0"
    aria-labelledby="banner-live"
    aria-label="Site notice banner"  
  >
    <p class="sr-only" id="banner-live">
      Site notice: {{ banner.message }}
    </p>

    <div class="marquee" aria-describedby="banner-live">
      <div #marqueeContent class="marquee-content"
           [style.--duration]="marqueeDuration"
           [style.--startX.px]="startX"
           [style.--endX.px]="endX"
           [style.--delay]="marqueeDelay">
        <span class="marquee-text">{{ banner.message }}</span>
      </div>
    </div>
  </div>
</div>

<nav aria-label="Skip navigation">
  <a href="#main-content" class="skip-to-content-link" (click)="skipToContent($event)">Skip to Main Content</a>
</nav>

<router-outlet></router-outlet>